import { Skeleton } from 'antd';
import classNames from 'classnames';
import { FC, HTMLAttributes } from 'react';

import './SkeletonServiceCard.scss';

interface SkeletonServiceCardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const SkeletonServiceCard: FC<SkeletonServiceCardProps> = ({ className, ...restProps }) => {
  return (
    <div {...restProps} className={classNames('custom-skeleton-service-card', className)}>
      <div className="custom-skeleton-service-card__avatar">
        <Skeleton.Avatar active size="large" />
      </div>
      <Skeleton.Input
        style={{
          height: '18px',
        }}
        active
        block
        size="small"
      />
      <Skeleton.Input
        style={{
          height: '18px',
        }}
        active
        block
        size="small"
      />
      <Skeleton.Input
        style={{
          height: '18px',
        }}
        active
        block
        size="small"
      />
      <Skeleton.Input
        style={{
          height: '18px',
        }}
        active
        size="small"
      />
      <div className="custom-skeleton-service-card__button">
        <Skeleton.Button active block size="large" />
      </div>
    </div>
  );
};
